import React from 'react';
import { Building2, Users, Briefcase, FileText } from 'lucide-react';

const statCards = [
  { key: 'total_firms', label: 'Total Firms', icon: Building2, color: 'blue' },
  { key: 'total_users', label: 'Total Users', icon: Users, color: 'green' },
  { key: 'total_cases', label: 'Total Cases', icon: Briefcase, color: 'yellow' },
  { key: 'total_documents', label: 'Total Documents', icon: FileText, color: 'purple' },
];

const colorMap = {
  blue: { bg: 'bg-blue-100', text: 'text-blue-600' },
  green: { bg: 'bg-green-100', text: 'text-green-600' },
  yellow: { bg: 'bg-yellow-100', text: 'text-yellow-600' },
  purple: { bg: 'bg-purple-100', text: 'text-purple-600' },
};

const OverviewTab = ({ data, loading }) => {
  return (
    <div className="space-y-8">
      {/* Stat Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {statCards.map((card) => {
          const Icon = card.icon;
          const colors = colorMap[card.color];
          return (
            <div key={card.key} className="bg-white rounded-lg shadow-sm border p-6">
              <div className="flex items-center justify-between mb-4">
                <div className={`p-3 rounded-full ${colors.bg}`}>
                  <Icon className={`h-6 w-6 ${colors.text}`} />
                </div>
              </div>
              {loading ? (
                <div className="space-y-2">
                  <div className="h-8 bg-gray-200 rounded animate-pulse w-16" />
                  <div className="h-4 bg-gray-200 rounded animate-pulse w-24" />
                </div>
              ) : (
                <>
                  <p className="text-3xl font-bold text-gray-900">
                    {data ? (data[card.key] ?? 0).toLocaleString() : '--'}
                  </p>
                  <p className="text-sm text-gray-500 mt-1">{card.label}</p>
                </>
              )}
            </div>
          );
        })}
      </div>

    </div>
  );
};

export default OverviewTab;
